<template>
	<article class="bio-modal">
		<div class="bio-modal__img">
			<img :src="img" />
		</div>
		<div class="bio-modal__content">
			<h1 class="p1 --bold" v-html="full_name" />
			<h2 class="p2" v-html="title" />
			<hr />
			<div class="bio-modal__bio-text p2" v-html="bio" />
		</div>
	</article>
</template>

<script>
/**
 * Bio Modal Component
 *
 * important:
 * The Bio content expects HTML. Please wrap each paragraph in a <p> tag.
 */
export default {
	name: "BioModal",
	data() {
		return {
			full_name: "",
			title: "",
			img: "",
			bio: ""
		};
	},
	methods: {
		update: function (person) {
			this.full_name = person.full_name;
			this.title = person.title;
			this.img = person.img;
			this.bio = person.bio;
		}
	}
};
</script>

<style lang="scss">
#bio-modal-id {
	padding: 47px 49px;

	.container {
		margin: 0 auto;
	}
}

.bio-modal {
	overflow: hidden;
	position: relative;

	&__img {
		margin-bottom: 24px;
		max-width: 162px;

		img {
			display: block;
			height: auto;
			width: 100%;
		}
	}

	&__content {
		h1 {
			margin: 0;
		}

		h2 {
			font-weight: normal;
		}

		hr {
			margin-bottom: 20px;
		}

		.p2 > p {
			@include p2;
		}
	}

	@include from-md {
		&__img {
			left: 0;
			position: absolute;
			top: 0;
			z-index: 0;
		}

		&__content {
			background-color: $color--white;
			margin-left: 135px;
			margin-top: 48px;
			padding: 25px 32px;
			position: relative;
			z-index: 1;
		}
	}
}
</style>
